import React from 'react';

const CloseIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2.66669 2.66667L13.3334 13.3333' stroke='black' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M13.3334 2.66667L2.66669 13.3333' stroke='black' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export default CloseIcon;